import React from 'react';
import { useParams } from 'react-router-dom';

export default function CharacterPage() {
  const { id } = useParams();

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Detalles del Personaje</h1>
      <p>Este será el detalle del personaje con ID: <strong>{id}</strong></p>
      {/* Aquí luego puedes hacer fetch a Supabase para mostrar info real */}
    </div>
  );
}